import {filter} from 'lodash';

const state = () => ({
   careers: [],
});

const getters = {
   count: state => state.careers.length,
};

const actions = {};

const mutations = {
   addCareer(state, {career}) {
      state.careers.push(career);
   },
   removeCareer(state, {career}) {
      state.careers = filter(
         state.careers,
         storedCareer =>
            storedCareer.jobRole !== career.jobRole || storedCareer.jobDomain !== career.jobDomain
      );
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/favorites.js